<template>
  <div class="rhlistDrawer">
    <Drawer
      :mask-closable="false"
      class="common-drawer"
      :title="title"
      v-model="showInDrawer"
      :width="dologwidth"
      @on-close="drwcloseDrawer"
      :scrollable="true"
    >
      <Form
        ref="formValidate"
        :model="formData"
        :rules="ruleValidate"
        label-position="top"
      >
        <Row :gutter="16">
          <Col span="24">
            <FormItem label="设备名称" prop="name">
              <Input
                v-model="formData.name"
                name="mo-name"
                placeholder="请输入"
              />
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="全局编号" prop="globalCode">
              <Input
                v-model="formData.globalCode"
                name="mo-globalCode"
                placeholder="请输入"
              />
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="客户编号">
              <Input v-model="formData.consumerCode" placeholder="请输入" />
            </FormItem>
          </Col>
          <Col v-if="showInDrawer" span="24" :key="8558">
            <FormItem label="设备类型" prop="deviceTypeId">
              <Select
                id="mo-deviceTypeId"
                v-model="formData.deviceTypeId"
                placeholder="请选择"
              >
                <OptionGroup
                  :label="device.value"
                  :key="index"
                  v-for="(device, index) in dataCenter.deviceType"
                >
                  <Option
                    :key="ind"
                    :value="device2.id"
                    v-for="(device2, ind) in device.children"
                  >
                    {{ device2.value }}</Option
                  >
                </OptionGroup>
              </Select>
            </FormItem>
          </Col>
          <template v-if="showInDrawer">
            <Col span="24" v-if="!userRole.includes('c')">
              <FormItem label="所属客户" prop="tenantId">
                <Select
                  v-model="formData.tenantId"
                  @on-change="changeCus"
                  placeholder="请选择"
                  id="mo-tenantId"
                >
                  <Option
                    :key="index"
                    :value="brand.id"
                    v-for="(brand, index) in list"
                  >
                    {{ brand.value }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
          </template>
          <Col span="24" v-if="formData.tenantId">
            <FormItem label="所在设备组" prop="workshopId">
              <Row>
                <Col span="22">
                  <Select
                    v-model="formData.workshopId"
                    @on-change="changeWs"
                    placeholder="请选择"
                    style="width: 95%"
                    id="mo-workshopId"
                  >
                    <Option
                      :key="index"
                      :value="brand.id"
                      :default-label="brand.value"
                      :label-in-value="true"
                      v-for="(brand, index) in curWorkShops"
                      >{{ brand.value }}</Option
                    >
                  </Select>
                </Col>
                <Col class="lan" span="2">
                  <div @click="workshopPop = true">编辑</div>
                </Col>
              </Row>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="规格型号" prop="specifications">
              <Input v-model="formData.specifications" placeholder="请输入" />
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="设备制造商" prop="manufacturer">
              <Input v-model="formData.manufacturer" placeholder="请输入" />
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div class="drawer-footer">
        <Button
          type="primary"
          @click="submitForm('formValidate')"
          :loading="btnLoading"
          id="equmi-sub"
          >提交</Button
        >
        <Button style="margin-left: 8px" @click="drwcloseDrawer">取消</Button>
      </div>
      <div class="rh-model" v-if="timbo" @click="modelmehods"></div>
    </Drawer>

    <Workshop
      :khname="khname"
      ref="workModal"
      :workshopPop.sync="workshopPop"
      :closePop="closePop"
      @setWorkshopId="setWorkshopId"
      :refreshWorkshop="refreshWorkshop"
      :curWorkShops="curWorkShops"
      :curItemDetail="curItemDetail"
      :formData="formData"
      @end="end"
    >
    </Workshop>
  </div>
</template>

<script>
import api from "@/api";
import ls from "store2";
import deepcopy from "deepcopy";
import Workshop from "./workshop-modal";
import { mapState } from "vuex";

export default {
  name: "elqudirwer",
  props: {
    showDrawer: Boolean,
    closeDrawer: Function,
    dataCenter: Object,
    getLists: Function,
    curItemDetail: Object,
    timernum: {}, //多少秒自动关闭
  },
  components: {
    Workshop,
  },

  computed: {
    ...mapState({
      dologwidth: (state) => state.dologwidth,
    }),
  },
  data() {
    const validatePass = (rule, value, callback) => {
      if (value) {
        callback(new Error("请选择所在设备组"));
      } else {
        callback();
      }
    };
    return {
      deviceTypeIdbo: true,
      title: "",
      tttimer: null,
      list: [],
      timbo: false,
      userRole: ls.get("userRole"),
      workshopPop: false,
      showInDrawer: false,
      formData: {
        name: "",
        globalCode: "",
        workshopId: "",
        deviceTypeId: "",
        tenantId: "",
      },
      khname: "",
      curWorkShops: [],
      btnLoading: false,
      ruleValidate: {
        name: [
          {
            required: true,
            message: "请填写设备名称",
            trigger: "blur",
          },
        ],
        globalCode: [
          {
            required: true,
            message: "请填写全局编号",
            trigger: "blur",
          },
        ],
        workshopId: [
          {
            required: true,
            message: "请选择所在设备组",
            // validator: validatePass,
            trigger: "change",
          },
        ],
        deviceTypeId: [
          {
            required: true,
            message: "请选择设备类型",
            trigger: "change",
          },
        ],
        tenantId: [
          {
            required: true,
            message: "请选择所属客户",
            trigger: "change",
          },
        ],
      },
    };
  },
  mounted() {},
  methods: {
    modelmehods() {
      this.$Modal.info({
        title: "提示",
        content: "页面编辑超时，请重新打开",
        onOk: () => {
          this.drwcloseDrawer();
        },
      });
    },
    drwcloseDrawer() {
      clearTimeout(this.tttimer);
      this.tttimer = null;
      this.closeDrawer();
    },
    setregulartimer() {
      clearTimeout(this.tttimer);
      this.tttimer = null;
      this.tttimer = setTimeout(() => {
        this.timbo = true;
        clearTimeout(this.tttimer);
      }, this.timernum);
    },
    end() {
      this.khname = "";
    },
    submitForm(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.btnLoading = true;

          api
            .axss("post", "/ocm-oil-site/device/edit", this.formData)
            .then((res) => {
              this.btnLoading = false;
              if (res.code === "00000") {
                this.$Message.success("提交成功");

                this.closeDrawer(); // 关闭弹窗
                this.getLists(); // 刷新列表
              }
            })
            .catch((error) => {
              this.btnLoading = false;
            });
        }
      });
    },
    setWorkshopId(item) {
      let formDataCopy = deepcopy(this.formData);
      let itemCopy = deepcopy(item);
      formDataCopy.workshopId = itemCopy.id;
      formDataCopy.workshopName = itemCopy.value;
      this.formData = formDataCopy;
    },
    refreshWorkshop(cid) {
      // this.$store.dispatch('listCollection','workShop') // 设备组
      const datas = {
        size: 200,
        type: "workShop",
        gangedValueMap: {
          tenantId: cid || this.formData.tenantId,
        },
      };
      api.axss("post", "/ocm-admin/select", datas).then((res) => {
        if (res.code === "00000") {
          this.curWorkShops = res.data.records;
        }
      });
    },
    changeCus(item) {
      const consumer = JSON.parse(JSON.stringify(this.dataCenter.consumer));

      if (item) {
        this.khname = consumer.find((element) => element.id == item).value;
      }

      // const consumer=this.dataCenter.consumer
      // this.khname= (consumer.find(element=>element.id=item)).value

      delete this.formData.workshopId;
      this.refreshWorkshop(this.formData.tenantId);
    },
    changeWs(id) {
      this.curWorkShops.forEach((item) => {
        if (item.id === id) this.formData.workshopName = item.value;
      });
      // for(let item of this.$refs.formValidate.fields) {
      //     if(item.prop === 'workshopId') item.resetFields()
      // }
    },
    closePop() {
      this.workshopPop = false;
    },
    reset(key) {
      Object.keys(this[key]).forEach((item) => {
        this[key][item] = "";
      });
    },
  },
  watch: {
    curItemDetail: {
      handler: function (newValue, oldValue) {
        const consumer = this.dataCenter.consumer;

        if (newValue !== oldValue) this.$refs.formValidate.resetFields();
        if (newValue.id) {
          this.title = "编辑设备";

          if (newValue.id) {
            this.formData = newValue;
          }
          if (newValue.consumerTenantId != oldValue.consumerTenantId) {
            this.formData.tenantId = newValue.consumerTenantId;

            this.refreshWorkshop(newValue.consumerTenantId);
            // this.khname= (consumer.find(element=>element.id= this.formData.tenantId)).value
          }
        } else {
          this.title = "新增设备";
          this.formData = {};
        }
        this.$nextTick(() => {
          if (this.userRole.includes("c")) {
            this.formData.tenantId = this.list[0].id;
            this.refreshWorkshop(this.formData.tenantId);
          }
        });
      },
      deep: true,
    },
    showDrawer: {
      handler: function (newValue, oldValue) {
        if (newValue) {
          this.timbo = false;
          if (this.formData.id) {
            this.setregulartimer();
          }
          if (this.userRole == "m0") {
            this.list = this.dataCenter.consumer.filter((e) => {
              if (e.groupAuthorityString == "rw") {
                return true;
              }
            });
          } else {
            this.list = this.dataCenter.consumer;
          }
        }
        this.showInDrawer = newValue;
      },
      deep: true,
    },
  },
};
</script>

<style lang='less'>
.rhlistDrawer {
}

.iconWrap {
  display: inline-block;
  width: 10%;
  text-align: right;

  .addOilIcon {
    font-size: 30px;
    vertical-align: middle;
    cursor: pointer;
  }
}

.lan {
  color: rgb(12, 71, 157);
  cursor: pointer;
}
</style>